export default {"src":"/_next/static/image/public/images/flags/flag_90.05b69f80367e811ab6a48da10a4b3657.svg","height":16,"width":24};